import styled from 'styled-components';
import { palette } from 'styled-tools';

export const GradientBg = styled.div`
	background: linear-gradient(180deg, rgba(226, 234, 255, 0) 0%, #e2eaff 100%);
`;

export const AdditionalContentWrapper = styled.div`
	background: ${palette('gray0')};
	position: relative;
	overflow: auto;
`;
